export default __webpack_public_path__ + "static/media/arrowForwardHelp@2x.07bf3d10.png";